import type React from "react";

type SectionHeaderProps = {
  title: string;
  children?: React.ReactNode;
};

export function SectionHeader({ title, children }: SectionHeaderProps) {
  return (
    <div className="mb-4 flex min-h-[34px] items-center justify-between gap-3">
      <h2 className="m-0 text-base font-bold text-slate-950">{title}</h2>
      {children}
    </div>
  );
}
